import { ClustersIcon } from "@/components/Icons/ClustersIcon";
import { EarningsIcon } from "@/components/Icons/EarningsIcon";
import { KubernetesIcon } from "@/components/Icons/KubernetesIcon";
import { ModelsIcon } from "@/components/Icons/ModelsIcon";
import { Tool } from "@/types";
import { HomeIcon } from "@/components/Icons/HomeIcon";
import { CloudIcon } from "@/components/Icons/CloudIcon";
import { WorkerIcon } from "@/components/Icons/WorkerIcon";
import { ExplorerIcon } from "@/components/Icons/ExplorerIcon";
import { InferenceIconRound } from "@/components/Icons/InferenceIconRound";
import { CloudLogo, CloudLogoLight } from "@/components/Icons/CloudLogo";
import { WorkerLogo } from "@/components/Icons/WorkerLogo";
import { ExplorerLogo } from "@/components/Icons/ExplorerLogo";
import { WorkerIcon2 } from "@/components/Icons/WorkerIcon2";
import { AuthIcon } from "@/components/Icons/AuthIcon";
import { AuthLogo } from "@/components/Icons/AuthLogo";
import { SettingsIcon } from "@/components/Icons/SettingsIcon";
import { DocumentIcon } from "@/components/Icons/DocumentIcon";
import { StakingIcon } from "@/components/Icons/StakingIcon";
import { StakingLogo } from "@/components/Icons/StakingLogo";
import { AIModelsIcon } from "@/components/Icons/AIModelsIcon";
import { AIModelsLogo, AIModelsLogoLight } from "@/components/Icons/AIModelsLogo";
import { VirtualMachineIcon } from "@/components/Icons/VirtualMachineIcon";
import env from "@/env";
import { ContainerIcon } from "@/components/Icons/ContainerIcon";
import ChatHistoryIcon from "@/components/Icons/ChatHistoryIcon";
import { CreditCardIcon } from "@/components/Icons/CreditCardIcon";
import { AgentIcon } from "@/components/Icons/AgentIcon";
import { WorkflowFolderIcon } from "@/components/Icons/WorkflowFolderIcon";
import { DigitalKeyIcon } from "@/components/Icons/DigitalKeyIcon";
import { AnalyticsEventType } from "./analytics";
import { LockClosedIcon } from "@/components/Icons/LockClosedIcon";
import { RayClusterIcon } from "@/components/Icons/RayClusterIcon";
import { BareMetalIcon } from "@/components/Icons/BareMetalIcon";
import { SidebarCloudIcon } from "@/components/Icons/SidebarCloudIcon";
import { SidebarDashboardIcon } from "@/components/Icons/SidebarDashboardIcon";
import { SidebarIntelligenceIcon } from "@/components/Icons/SidebarIntelligenceIcon";
import { UserCircleIcon } from "@heroicons/react/24/outline";

export const TOOL_OPTIONS = [
  {
    value: "ai",
    label: "Intelligence",
    icon: AIModelsIcon,
    sidebarIcon: SidebarIntelligenceIcon,
    logo: AIModelsLogo,
    logoLight: AIModelsLogoLight,
    href: "/ai",
    bg: "/assets/images/bg_models.png",
    theme: "light",
    menuItems: [
      // { value: "plans", label: "Plans", icon: CreditCardIcon, href: "/ai/plans", requiresLogin: true },
      { value: "chat", label: "Chat", icon: ChatHistoryIcon, href: "/ai/app", requiresLogin: true },
      { value: "models", label: "Models", icon: ModelsIcon, href: "/ai/models" },
      { value: "agents", label: "Agents", icon: AgentIcon, href: "/ai/agents" },
      // { value: "re", label: "Retrieval Engine", href: "/ai/re" },
      {
        value: "agentic-workflow-editor",
        label: "Agentic Workflow Editor",
        icon: WorkflowFolderIcon,
        href: "/ai/agentic-workflow-editor",
        requiresLogin: true,
        showInDelayedLogin: true
      },
      {
        value: "training",
        label: "Training",
        icon: InferenceIconRound,
        href: "/ai/training",
        requiresLogin: true,
        showInDelayedLogin: true
      },
      {
        value: "api-keys",
        label: "API Keys and Secrets",
        icon: DigitalKeyIcon,
        href: "/ai/api-keys"
      }
    ]
  },
  {
    value: "cloud",
    label: "Cloud",
    icon: CloudIcon,
    sidebarIcon: SidebarCloudIcon,
    logo: CloudLogo,
    logoLight: CloudLogoLight,
    href: "/cloud/home",
    prefix: "/cloud",
    bg: "/assets/images/bg_cloud.png",
    theme: "light",
    menuItems: [
      {
        value: "home",
        label: "Home",
        icon: HomeIcon,
        sidebarIcon: SidebarDashboardIcon,
        href: "/cloud/home"
      },
      {
        value: "vmaas",
        label: "Virtual Machine",
        icon: VirtualMachineIcon,
        href: "/cloud/virtual-machines",
        disabled: !env.FEATUREFLAG_VMAAS_DEPLOY
      },
      {
        value: "container",
        label: "Container",
        icon: ContainerIcon,
        href: "/cloud/container",
        disabled: !env.FEATUREFLAG_CONTAINER_DEPLOY
      },
      {
        value: "managedServices",
        label: "Managed Services",
        icon: ClustersIcon,
        subMenuItems: [
          {
            value: "bareMetal",
            label: "Bare Metal",
            icon: BareMetalIcon,
            href: "/cloud/bare-metal",
            disabled: !env.FEATUREFLAG_BARE_METAL_DEPLOY
          },
          {
            value: "confidentialCompute",
            label: "Confidential Compute",
            icon: LockClosedIcon,
            href: "/cloud/confidential-compute",
            disabled: false
          },
          {
            value: "kubernetes",
            label: "Kubernetes",
            icon: KubernetesIcon,
            href: "/cloud/kubernetes",
            disabled: !env.FEATUREFLAG_KUBERNETES_DEPLOY
          },
          {
            value: "ray",
            label: "Ray",
            icon: RayClusterIcon,
            href: "/cloud/ray",
            disabled: false
          }
        ]
      }
      // { value: "clusters", label: "Ray", icon: RayClusterIcon, href: "/cloud/clusters" }
      // {
      //   value: "megaClusters",
      //   label: "Mega-Ray",
      //   icon: ClustersIcon,
      //   href: "/cloud/mega-clusters"
      // },
      // {
      //   value: "models",
      //   label: "Models",
      //   icon: ModelsIcon,
      //   href: "/cloud/models",
      //   disabled: true
      // }
    ]
  },
  {
    value: "explorer",
    label: "Explorer",
    icon: ExplorerIcon,
    logo: ExplorerLogo,
    sidebarIcon: ExplorerLogo,
    href: "/explorer/home",
    prefix: "/explorer",
    bg: "/assets/images/bg_explorer.png",
    // theme: "dark",
    menuItems: [
      {
        value: "home",
        label: "Home",
        icon: HomeIcon,
        href: "/explorer/home",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      },
      {
        value: "devices",
        label: "Workers",
        icon: WorkerIcon2,
        href: "/worker/devices/explorer",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      },
      {
        value: "epochs",
        label: "Epochs",
        href: "/explorer/epochs",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      },
      {
        value: "inferences",
        label: "Inferences",
        icon: InferenceIconRound,
        href: "/explorer/inferences",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      },
      {
        value: "clusters",
        label: "Clusters",
        icon: ClustersIcon,
        href: "/explorer/clusters",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      },
      ...(env.FEATUREFLAG_STAKING_DASHBOARD_ENABLED
        ? [
            {
              value: "staking-dashboard",
              label: "Staking Dashboard",
              icon: InferenceIconRound,
              href: "/explorer/staking-dashboard",
              analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
            }
          ]
        : []),
      {
        value: "blockRewards",
        label: "Block Rewards",
        icon: InferenceIconRound,
        href: "/explorer/epoch-rewards",
        analyticEvent: AnalyticsEventType.EXPLORE_TAB_CLICKED
      }
    ]
  },
  {
    value: "worker",
    label: "worker",
    logo: WorkerLogo,
    icon: WorkerIcon,
    href: "/worker/dashboard/devices",
    prefix: "/worker/dashboard",
    bg: "/assets/images/bg_worker.png",
    theme: "dark",
    menuItems: [
      {
        value: "devices",
        label: "Workers",
        icon: WorkerIcon2,
        href: "/worker/dashboard/devices"
      },
      {
        value: "Earnings & Rewards",
        label: "Earnings & Rewards",
        icon: EarningsIcon,
        href: "/worker/dashboard/earnings-and-rewards"
      },
      { value: "staking", label: "Staking", href: "/worker/dashboard/staking/devices" }
    ]
  },
  {
    value: "id",
    label: "IO ID",
    icon: AuthIcon,
    logo: AuthLogo,
    href: "/id/account/overview",
    bg: "/assets/images/bg_auth.png",
    theme: "dark",
    menuItems: [
      // {
      //   value: "overview",
      //   label: "Overview",
      //   icon: UserCircleIcon,
      //   href: "/id/account/overview",
      //   requiresLogin: true
      // },
      // {
      //   value: "iocloud",
      //   label: "io.cloud",
      //   icon: SidebarCloudIcon,
      //   href: "/id/account/io-cloud",
      //   requiresLogin: true
      // },
      // {
      //   value: "io.intelligence",
      //   label: "io.intelligence",
      //   icon: SidebarIntelligenceIcon,
      //   href: "/id/account/intelligence",
      //   requiresLogin: true
      // },
      {
        value: "funds",
        label: "Billing History",
        icon: InferenceIconRound,
        href: "/id/funds",
        requiresLogin: true
      },
      {
        value: "settings",
        label: "Settings",
        icon: SettingsIcon,
        href: "/id/account/settings",
        requiresLogin: true
      },
      {
        value: "acknowledgment",
        label: "User Acknowledgment",
        icon: DocumentIcon,
        href: "/id/account/acknowledgment",
        requiresLogin: true
      }
    ]
  },
  ...(env.FEATUREFLAG_CO_STAKING_ENABLED || env.FEATUREFLAG_STAKING_DASHBOARD_ENABLED
    ? [
        {
          value: "staking",
          label: "Staking",
          icon: StakingIcon,
          logo: StakingLogo,
          href: "/staking/my-co-staking",
          bg: "/assets/images/bg_coin.png",
          menuItems: [
            ...(env.FEATUREFLAG_CO_STAKING_ENABLED
              ? [
                  {
                    value: "my-co-staking",
                    label: "My Co-Staking Devices",
                    href: "/staking/my-co-staking"
                  }
                ]
              : []),
            ...(env.FEATUREFLAG_SAFETY_MODULE_ENABLED
              ? [
                  {
                    value: "safety-module",
                    label: "IO Safety Module",
                    href: "/staking/safety-module"
                  }
                ]
              : [])
          ]
        }
      ]
    : [])
] as Tool[];
